import { useEffect, useState } from 'react';
import { getTryOnAddresses, getTryOnBookings, saveTryOnAddresses, updateTryOnBooking } from '../services/tryOnService';

function AdminTryOn() {
  const [bookings, setBookings] = useState([]);
  const [addresses, setAddresses] = useState({ address1: '', address2: '' });
  const [message, setMessage] = useState('');

  const load = () => getTryOnBookings().then(setBookings).catch((error) => setMessage(error.message));
  useEffect(() => {
    load();
    getTryOnAddresses().then(setAddresses).catch((error) => setMessage(error.message));
  }, []);

  async function save(event) {
    event.preventDefault();
    try {
      await saveTryOnAddresses(addresses);
      setMessage('Try-on addresses saved.');
    } catch (error) {
      setMessage(error.message);
    }
  }

  async function change(id, status) {
    try {
      await updateTryOnBooking(id, status);
      setMessage('Booking updated. Please confirm directly with the customer on WhatsApp.');
      load();
    } catch (error) {
      setMessage(error.message);
    }
  }

  return (
    <div className="admin-overview-container">
      <div className="admin-page-header">
        <div><h1 className="admin-page-title">Try-on requests</h1>
          <p className="admin-page-subtitle">Review requests and confirm appointments personally on WhatsApp.</p></div>
      </div>
      {message && <div className="admin-alert info" role="status">{message}</div>}
      <div className="admin-card-container">
        <div className="admin-card-header"><h3>Try-on locations</h3></div>
        <form onSubmit={save} className="form-grid-2">
          {['address1', 'address2'].map((key, index) => (
            <label className="admin-field-label" key={key}>Address {index + 1}
              <input value={addresses[key] || ''} maxLength={300}
                onChange={(e) => setAddresses({ ...addresses, [key]: e.target.value })} />
            </label>
          ))}
          <button className="admin-btn-primary" type="submit">Save addresses</button>
        </form>
      </div>
      <div className="admin-card-container" style={{ marginTop: 24 }}>
        <div className="admin-card-header"><h3>Requests ({bookings.length})</h3>
          <button type="button" onClick={load}>Refresh</button></div>
        <div className="zevi-booking-list">
          {bookings.map((booking) => {
            const phone = booking.phone.replace(/\D/g, '').replace(/^0/, '94');
            const text = encodeURIComponent(`Hello ${booking.customer_name}, regarding your ZEVI try-on request for ${booking.requested_date} at ${booking.requested_time}.`);
            return (
              <article key={booking.id}>
                <strong>{booking.customer_name}</strong>
                <span>{booking.requested_date} · {booking.requested_time} · {booking.status}</span>
                <a href={`tel:${booking.phone}`}>{booking.phone}</a>
                <a href={`https://wa.me/${phone}?text=${text}`} target="_blank" rel="noreferrer">Contact on WhatsApp</a>
                <select aria-label={`Status for ${booking.customer_name}`} value={booking.status}
                  onChange={(e) => change(booking.id, e.target.value)}>
                  <option value="requested">Requested</option>
                  <option value="confirmed">Confirmed with customer</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </article>
            );
          })}
          {!bookings.length && <p>No try-on requests yet.</p>}
        </div>
      </div>
    </div>
  );
}

export default AdminTryOn;